import { useParams } from 'react-router-dom';
import { useProject } from '../apis/hooks/useProject';
import ProjectModel from '@models/ProjectModel';

export const useCurrentProject = (): ProjectModel | undefined => {
  const params = useParams();
  const { data: project } = useProject(params.projectId);
  return project;
};
